import { httpClient } from '@/api/httpClient';
import {
  mapPaginatedResource,
  type PaginatedApiResource,
  type PaginatedResult,
} from '@/api/pagination.types';
import {
  mapApiResourceToEmailLogEntryDetail,
  mapApiResourceToEmailLogEntrySummary,
  type EmailLogEntryDetail,
  type EmailLogEntryDetailApiResource,
  type EmailLogEntrySummary,
  type EmailLogEntrySummaryApiResource,
  type EmailLogQuery,
} from './emailLogApi.types';

const WORKSPACE_EMAIL_LOG_PATH = '/me/workspace/email-log';

function buildEmailLogEntryPath(entryId: string): string {
  return WORKSPACE_EMAIL_LOG_PATH + '/' + encodeURIComponent(entryId);
}

export async function fetchWorkspaceEmailLog(
  query: EmailLogQuery
): Promise<PaginatedResult<EmailLogEntrySummary>> {
  const trimmedSearch = query.search.trim();
  const response = await httpClient.get<PaginatedApiResource<EmailLogEntrySummaryApiResource>>(
    WORKSPACE_EMAIL_LOG_PATH,
    {
      params: {
        page: query.page,
        page_size: query.pageSize,
        search: trimmedSearch.length === 0 ? undefined : trimmedSearch,
        status: query.status === null ? undefined : query.status,
      },
    }
  );
  return mapPaginatedResource(response.data, mapApiResourceToEmailLogEntrySummary);
}

export async function fetchWorkspaceEmailLogEntry(entryId: string): Promise<EmailLogEntryDetail> {
  const response = await httpClient.get<EmailLogEntryDetailApiResource>(
    buildEmailLogEntryPath(entryId)
  );
  return mapApiResourceToEmailLogEntryDetail(response.data);
}

export async function resendWorkspaceEmailLogEntry(entryId: string): Promise<EmailLogEntryDetail> {
  const response = await httpClient.post<EmailLogEntryDetailApiResource>(
    buildEmailLogEntryPath(entryId) + '/resend'
  );
  return mapApiResourceToEmailLogEntryDetail(response.data);
}
